function initialiseProducts(){
        // Cargar Swiper solo si es necesario
        if (document.querySelector('[data-product-swiper]')) {
            // Inicializar Swiper en cada product card
            document.querySelectorAll('[data-product-swiper]').forEach(container => {
            const slides = container.querySelectorAll('.swiper-slide');
            if (slides.length <= 1) return;

            // Inicializar Swiper
            const swiper = new Swiper(container, {
                slidesPerView: 1,
                spaceBetween: 0,
                loop: true,
                speed: 300,
                grabCursor: true,
                navigation: {
                nextEl: container.querySelector('.swiper-button-next'),
                prevEl: container.querySelector('.swiper-button-prev'),
                },
                pagination: {
                    el: container.querySelector('.swiper-pagination'),
                    clickable: true,
                    renderBullet: function (index, className) {
                        if (index >= 3) return '';
                        return `<span class="${className}"></span>`;
                    }
                },
                touchEventsTarget: 'container',
                simulateTouch: true,
                allowTouchMove: true,
                preventClicks: false,
                preventClicksPropagation: false,
            });

            /*
            // 👉 Añade comportamiento hover SOLO si es desktop y show_secondary_image is true
            if (window.matchMedia('(hover: hover)').matches && window.innerWidth >= 750) {
                container.addEventListener('mouseenter', () => {
                if (container.classList.contains('enable-hover-swap') && swiper.slides.length > 1) {
                    swiper.slideToLoop(1);
                }
                });
                container.addEventListener('mouseleave', () => {
                swiper.slideToLoop(0, 0); // Vuelve al primer slide sin animación
                });
            }
            */

            // 👉 Hover behavior only on desktop
            if (window.matchMedia('(hover: hover)').matches && window.innerWidth >= 750) {
                document.querySelectorAll('.product-card').forEach(card => {
                const container = card.querySelector('[data-product-swiper]');
                if (!container) return;
                const swiper = container.swiper; // Swiper instance already created above
                if (!swiper) return;

                // Mouse enter only when entering product-card
                card.addEventListener('mouseenter', () => {
                    if (container.classList.contains('enable-hover-swap') &&
                        swiper.slides.length > 1) {
                    swiper.slideToLoop(1);
                    }
                });
                // Mouse leave only when leaving product-card (NOT buttons)
                card.addEventListener('mouseleave', () => {
                    swiper.slideToLoop(0, 0); // instant reset
                });
                });
            }            

            });


        

        document.querySelectorAll('button.show-product__sizes').forEach(button => {
        button.addEventListener('click', () => {
            const parent = button.closest('product-card.product-card');
            if (!parent) return;

            const sizeButtons = parent.querySelectorAll('.sizes__btns button');

            // Remove 'showsizes' from any previously opened items
            document.querySelectorAll('product-card.product-card.showsizes').forEach(item => {
            item.classList.remove('showsizes');
            });

            // If only one size button — just click it, don't open sizes
            if (sizeButtons.length === 1) {
            sizeButtons[0].click();
            return;
            }
        
            // Add to the clicked product
            parent.classList.add('showsizes');
        });
        });


        // Remove class when clicking inside wrapper
        document.querySelectorAll('.sizes__wrapper.js-product-form').forEach(wrapper => {
        wrapper.addEventListener('click', e => {
            // ignore if click is on a button
            if (!e.target.closest('button')) {
            const parent = wrapper.closest('product-card.product-card');
            if (parent) {
                parent.classList.remove('showsizes');
            }
            }
        });
        });
        }
        

        } 


            
        function togglemakethisactive(el) {
        const wrapper = el.closest('.sizes__wrapper');
        if (!wrapper) return;

        // remove active from all children inside this wrapper
        wrapper.querySelectorAll('.active').forEach(btn => {
            btn.classList.remove('active');
        });

        // add active to the clicked one
        el.classList.add('active');

        // now search for the adjacent add-to-cart button
        const addToCartBtn = wrapper.querySelector('.btn.btn--large.add-to-cart');
        if (addToCartBtn) {
            addToCartBtn.classList.add('active');
            const newText = addToCartBtn.getAttribute('data-atctext');
            if (newText) {
            addToCartBtn.textContent = newText;
            }

            addToCartBtn.click();
        }

}

 
document.addEventListener("DOMContentLoaded", (event) => {
  initialiseProducts();
});
document.addEventListener("cart:refresh", (event) => {
  initialiseProducts();
});



function closesiszes(){
    document.querySelectorAll('product-card.product-card.showsizes').forEach(item => {
      item.classList.remove('showsizes');
    });
}

function addtocart(button){
 
// find adjacent .sizes__btns
  const sizesBtns = button.parentElement.querySelector('.sizes__btns');
  if (!sizesBtns) {
    console.warn("⚠️ No .sizes__btns found near the button.");
    return;
  }

  // find active item
  const activeItem = sizesBtns.querySelector('.sizes__wrapper--item.active');
  if (!activeItem) { 
    return;
  }

  // get data-id as integer
  const variantId = parseInt(activeItem.getAttribute('data-id'));

  if (isNaN(variantId)) {
    console.error("⚠️ Invalid or missing data-id on active size item.");
    return;
  }

    button.classList.add("is-loading"); 
    fetch('/cart/add.js', {
        method: 'POST',
        headers: {
        'Content-Type': 'application/json',
        },
        body: JSON.stringify({
        id: variantId,
        quantity: 1
        })
    })
    .then(response => response.json())
    .then(data => {
        console.log('Success:', data);
        // Update cart UI here 
        document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
         bubbles: true
        }));
        document.querySelector('[aria-controls="cart-drawer"]')?.click();
        button.classList.remove("is-loading");
    })
    .catch((error) => {
        console.error('Error:', error);
    });
 } 
